import React, { lazy, Suspense, memo } from "react";
import { useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import Loading from "components/shared-components/Loading";
import { lightTheme, darkTheme } from "configs/ThemeConfig";
import { resources } from "lang";
import useBodyClass from "utils/hooks/useBodyClass";
import Routes from "routes";
import { useLocation } from "react-router-dom";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { useAuthenticator } from "@aws-amplify/ui-react";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const Layouts = () => {
  //   const isSignedIn = useSelector((state) => state.auth.isSignedIn);
  //   const { authStatus, route } = useAuthenticator((context) => [context.route]);
  //   const isSignedIn =
  //     authStatus === "authenticated" || route === "authenticated";

  // use path to decide inital layout instead of auth status
  const location = useLocation();
  const protectedPath = location.pathname.startsWith(APP_PREFIX_PATH);
  const blankLayout = useSelector((state) => state.theme.blankLayout);
  console.log("Layouts", { blankLayout, location: location.pathname });

  //   const Layout = isSignedIn && !blankLayout ? AppLayout : AuthLayout;
  const Layout = protectedPath && !blankLayout ? AppLayout : AuthLayout;

  const locale = useSelector((state) => state.theme.locale);

  const direction = useSelector((state) => state.theme.direction);

  const currentTheme = useSelector((state) => state.theme.currentTheme);

  const currentAppLocale = resources[locale];

  useBodyClass(`dir-${direction}`);

  const themeConfig =
    currentTheme === "light" ? { ...lightTheme } : { ...darkTheme };

  return (
    <ConfigProvider
      theme={themeConfig}
      direction={direction}
      locale={currentAppLocale.antd}
    >
      <Suspense fallback={<Loading cover="content" />}>
        <Layout>
          <Routes />
        </Layout>
      </Suspense>
    </ConfigProvider>
  );
};

export default memo(Layouts);
